import { faArrowRightLong } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "twin.macro";

import boldSrc from "../../../assets/images/integrations/logos/bold-mark-white.svg";
import chargebeeSrc from "../../../assets/images/integrations/logos/chargebee-mark-white.svg";
import hubspotSrc from "../../../assets/images/integrations/logos/hubspot-mark-white.svg";
import recurlySrc from "../../../assets/images/integrations/logos/recurly-mark-white.svg";
import salesforceSrc from "../../../assets/images/integrations/logos/salesforce-logo-white.svg";
import stripeSrc from "../../../assets/images/integrations/logos/stripe-logo-white.svg";
import {
  BlueMenuItem,
  Integration,
  IntegrationIcon,
  Integrations,
  Menu as MenuBase,
  MenuItem,
  MenuItemAnchor,
  MenuLeft,
  MenuLeftCol,
  MenuLeftColContent,
  MenuRight,
  resourcesMenuWidth,
} from "./MenuStyles";
import { forIndustries, forTeams } from "./navItems";

const Menu = styled(MenuBase)`
  width: ${resourcesMenuWidth}px;
`;

const ResourcesMenu: React.FunctionComponent = () => (
  <Menu>
    <MenuLeft>
      <MenuLeftCol>
        <h5>Learn More</h5>
        <MenuLeftColContent>
          <div>
            <MenuItem to="/roi-calculator/">ROI Calculator</MenuItem>
            <MenuItem to="/customers/">Case Studies</MenuItem>
            <MenuItem to="/blog/">Blog</MenuItem>
            <MenuItemAnchor
              href="https://docs.prosperstack.com"
              target="_blank"
            >
              Documentation
            </MenuItemAnchor>
            <MenuItemAnchor
              href="https://developers.prosperstack.com"
              target="_blank"
            >
              API Reference
            </MenuItemAnchor>
          </div>
        </MenuLeftColContent>
      </MenuLeftCol>
      <MenuLeftCol>
        <h5>For Teams</h5>
        <MenuLeftColContent>
          <div>
            {forTeams.map((link) => (
              <MenuItem to={link.to} key={link.to}>
                {link.title}
              </MenuItem>
            ))}
          </div>
        </MenuLeftColContent>
      </MenuLeftCol>
      <MenuLeftCol>
        <h5>Industries</h5>
        <MenuLeftColContent>
          <div>
            {forIndustries.map((link) => (
              <MenuItem to={link.to} key={link.to}>
                {link.title}
              </MenuItem>
            ))}
          </div>
        </MenuLeftColContent>
      </MenuLeftCol>
    </MenuLeft>
    <MenuRight>
      <h5>Integrations</h5>
      <Integrations>
        <Integration to="/integrations/stripe/">
          <IntegrationIcon color="#635BFF">
            <img src={stripeSrc} width="28" alt="Stripe" />
          </IntegrationIcon>{" "}
          Stripe
        </Integration>
        <Integration to="/integrations/chargebee/">
          <IntegrationIcon color="#FF3300">
            <img src={chargebeeSrc} width="18" alt="Chargebee" />
          </IntegrationIcon>{" "}
          Chargebee
        </Integration>
        <Integration to="/integrations/recurly/">
          <IntegrationIcon color="#FFD706">
            <img src={recurlySrc} width="18" alt="Recurly" />
          </IntegrationIcon>{" "}
          Recurly
        </Integration>
        <Integration to="/integrations/salesforce/">
          <IntegrationIcon color="#00A1DF">
            <img src={salesforceSrc} width="20" alt="Salesforce" />
          </IntegrationIcon>{" "}
          Salesforce
        </Integration>
        <Integration to="/integrations/hubspot/">
          <IntegrationIcon color="#FC7A59">
            <img src={hubspotSrc} width="20" alt="HubSpot" />
          </IntegrationIcon>{" "}
          HubSpot
        </Integration>
        <Integration to="/integrations/bold/">
          <IntegrationIcon color="#E60045">
            <img src={boldSrc} width="16" alt="Bold" />
          </IntegrationIcon>{" "}
          Bold
        </Integration>
      </Integrations>
      <BlueMenuItem to="/integrations/">
        <span>
          See all integrations <FontAwesomeIcon icon={faArrowRightLong} />
        </span>
      </BlueMenuItem>
    </MenuRight>
  </Menu>
);

export default ResourcesMenu;
